export interface InputProps {
  type: string | any;
  name: string;
  value?: any;
  handleChange?: any;
  placeholder?: string;
  disable?: boolean;
  required?: boolean;
  ref?: string | any;
}

const Input: React.FC<InputProps> = ({
  required,
  disable,
  value,
  handleChange,
  type,
  name,
  placeholder,
  ref,
}) => {
  return (
    <input
      ref={ref}
      required={required}
      disabled={disable}
      type={type}
      value={value}
      onChange={handleChange}
      name={name}
      placeholder={placeholder || "Place holder"}
      className="md:h-10 h-8 w-full font-rom rounded-md md:text-sm text-xs my-3 px-3 border-2 border-stroke focus:ring-1 focus:outline-none"
    />
  );
};

export default Input;
